module.exports = __webpack_public_path__ + "img/magento-banner_medium.2b76ad05.webp";